import React, { useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { Col, Row, Container, Form, FormGroup, Label, Input } from 'reactstrap';
import { DisengagedFaceIcon, EngagedFaceIcon, ReactiveFaceIcon } from '../../icons';
import useCode from '../quick-codes/useCode';
import getContentFromCode from '../quick-codes/getContentFromCode';
import QRCode from 'react-qr-code';
import theme from '../../theme';
import { StyledButton } from '../shared/styled';
import usePulse from './usePulse';
import { Chart as ChartJS, ArcElement } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';

ChartJS.register(ArcElement, ChartDataLabels);

const EngagementOption = ({color, words, percentage, children, selected, onClick}) =>
{
    return (
        <Col xs="4" xl="4">
            <div style={{height:"358px", position:"relative"}}>
                <div className="engagement-option-bar" style={{height:`${percentage}%`, backgroundColor:color}}>
                    
                </div>
            </div>
            <div>
                <div style={{color, textAlign: "center"}}>
                    <div className={"engagement-option" + (selected ? " selected" : "")} onClick={onClick}>
                        {children}
                    </div>
                    <ol style={{listStyle: "none", margin: 0, padding: 0}}>
                        {words.map(word =>
                            <li>{word}</li>
                        )}
                    </ol>
                </div>
            </div>
        </Col>
    );
}

const CheckInSummary = ({ id: engagementPulseId }) => {
    const {loading, code } = useCode(engagementPulseId);
    const pulse = usePulse(engagementPulseId);

    const engagementOptionSelected = (value) => {
        console.log(pulse);
        pulse.setEngagementLevel(value);
    }

    return (
        <Container>
            <Row xs="12" sm="12" md="12" lg="12" xl="12">
                <Col xs="9" sm="9" md="9" lg="9" xl="9">
                    <Row><h2>Engagement Pulse</h2></Row>
                    <Row xl="12">
                        <EngagementOption color={theme.disengaged} words={['Tired', 'Distracted', 'Bored', 'Routine']} percentage={pulse.data?.disengaged / pulse.data?.total * 100} onClick={() => engagementOptionSelected(0)} selected={pulse.engagementLevel === 0}>
                            <DisengagedFaceIcon />
                        </EngagementOption>
                        <EngagementOption color={theme.engaged} words={['Present', 'Relaxed', 'Alert', 'Excited']} percentage={pulse.data?.engaged / pulse.data?.total * 100} onClick={() => engagementOptionSelected(1)} selected={pulse.engagementLevel === 1}>
                            <EngagedFaceIcon />
                        </EngagementOption>
                        <EngagementOption color={theme.reactive} words={['Anxious', 'Frustrated', 'Alarmed', 'Afraid']} percentage={pulse.data?.reactive / pulse.data?.total * 100} onClick={() => engagementOptionSelected(2)} selected={pulse.engagementLevel === 2}>
                            <ReactiveFaceIcon />
                        </EngagementOption>
                    </Row>
                </Col>
                <Col xs="3" sm="3" md="3" lg="3" xl="3">
                    <h2>Code</h2>
                    <h1>{loading ? "----" : (code ?? "----")}</h1>
                    <h6>Enter the above at www.nmestatecheckin.com/pulse</h6>

                    <QRCode value={`https://www.nmestatecheckin.com/pulse/${engagementPulseId}`} />
                </Col>
            </Row>
        </Container>
    );
}

const PulseCodeEntry = () => {
    const history = useHistory();
    const [code, setCode] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);

    const canSubmit = !loading && code.length === 4;

    const onGoClick = async () => {
        setLoading(true);
        
        const pulseId = await getContentFromCode(code);

        if(pulseId) {
            history.push(`/pulse/${pulseId}`);
        } else {
            setError("Incorrect Code, Please Try Again");
            setLoading(false);
        }
    }

    return (
        <Container>
            <Row xs="1" sm="1" md="2" lg="2" xl="2">
                <Col xs="9" sm="9" md="9" lg="9" xl="9">
                    <h2>Engagement Pulse</h2>
                    <Form>
                        <FormGroup>
                            <Label>Code</Label>
                            <Input placeholder='CODE' value={code} maxLength={4} onChange={(e) => { setCode(e.target.value.toUpperCase()) }} />
                        </FormGroup>
                        {error && (
                            <p style={{color: theme.reactive}}>{error}</p>
                        )}
                        <StyledButton onClick={onGoClick} disabled={!canSubmit}>Go</StyledButton>
                    </Form>
                </Col>
            </Row>
        </Container>
    );
}

export const EngagementPulse = () => {
    const params = useParams();
    if(params.id)
    {
        return <CheckInSummary {...params} />;
    }

    return <PulseCodeEntry />
}

export default EngagementPulse;